import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { FcMultipleInputs } from 'react-icons/fc';
import { MdEdit } from 'react-icons/md';

import DataTable from 'common-components/DataTable';
import { columns } from './urlTableColumns';
import './urlTable.style.css';

const UrlTable = ({
  priviledge,
  isLoading,
  tableData,
  onRowEdit }) => {

  const setDefaultColumn = () => {
    if (!columns.some(
      column => { return column.title === "Status" })) {
      columns.push(
        {
          title: "Status",
          key: "status",
          headerClassName: 'status',
          render: (row) => {
            if (row.status === 2) return <div className='status-container rejected'>Ignored</div>;
            if (row.status === 0) return <div className='status-container pending'>Unreviewed</div>;
            else return <div className='status-container success'>Reviewed</div>;
          },
        }
      );
    };

    if (!columns.some(
      column => { return column.title === " " })) {
      columns.push(
        {
          title: " ",
          key: "multi_cat",
          headerClassName: 'column-multi-cat',
          sortable: false,
          render: (row) => {
            if (row.all_categories.length > 1) return <div ><FcMultipleInputs className='multi-cat-icon' /></div>;
            else return <div />;
          },
        });
    };
  };

  useEffect(() => {
    setDefaultColumn();
  }, [tableData]);

  const actionComponents = ({ row, rowIndex, showLoader, hideLoader, getNextRow }) => {
    return (
      <div className='tooltip'>
        <div className="tooltiptext">Edit</div>
        <span>
          <MdEdit className='edit' onClick={() => onRowEdit(row, getNextRow)} />
        </span>
      </div>
    );
  };

  return (
    <>
      <div className='url-table-container'>
        <DataTable
          title="URLs TO REVIEW"
          wrapperClassName='review-url-table'
          rows={tableData}
          columns={columns}
          pageSizeOptions={[100, 50, 25, 15, 10]}
          searchableFields={["normalized_url", "original_category", "score", "tag", "prevalence_info"]}
          ActionComponent={(priviledge.is_admin || priviledge.is_reviewer) ? actionComponents : null}
          isLoading={isLoading}
        />
      </div>
    </>
  )
};

const mapStateToProps = ({
  authentication: { priviledge } }) => ({
    priviledge,
  });

export default connect(mapStateToProps)(UrlTable);
